import {
  IoCheckmarkOutline,
  IoCloseOutline,
  IoEllipsisHorizontalOutline,
  IoPauseOutline,
  IoPlayOutline,
} from "react-icons/io5";
import { defineMessage } from "react-intl";

export const HOLDERS_SORT_VALUE_NAME_ASC = "name_asc";
export const HOLDERS_SORT_VALUE_NAME_DESC = "name_desc";
export const HOLDERS_SORT_VALUE_DATE_ASC = "created_asc";
export const HOLDERS_SORT_VALUE_DATE_DESC = "created_desc";

export const HOLDERS_SORTS = {
  [HOLDERS_SORT_VALUE_NAME_ASC]: {
    value: HOLDERS_SORT_VALUE_NAME_ASC,
    message: defineMessage({ defaultMessage: "Nom (A-Z)" }),
  },
  [HOLDERS_SORT_VALUE_NAME_DESC]: {
    value: HOLDERS_SORT_VALUE_NAME_DESC,
    message: defineMessage({ defaultMessage: "Nom (Z-A)" }),
  },
  [HOLDERS_SORT_VALUE_DATE_ASC]: {
    value: HOLDERS_SORT_VALUE_DATE_ASC,
    message: defineMessage({ defaultMessage: "Date de création croissante" }),
  },
  [HOLDERS_SORT_VALUE_DATE_DESC]: {
    value: HOLDERS_SORT_VALUE_DATE_DESC,
    message: defineMessage({ defaultMessage: "Date de création décroissante" }),
  },
};

export const HOLDERS_SORT_LIST = Object.values(HOLDERS_SORTS);

// ============================================================

export const HOLDERS_VALIDATION_STATES_VALUE_VALIDATED = "validated";
export const HOLDERS_VALIDATION_STATES_VALUE_NOT_VALIDATED = "not_validated";

export const HOLDERS_VALIDATION_STATES = {
  [HOLDERS_VALIDATION_STATES_VALUE_VALIDATED]: {
    id: HOLDERS_VALIDATION_STATES_VALUE_VALIDATED,
    colors: ["green.600", "green.300"],
    icon: IoCheckmarkOutline,
    label: defineMessage({ defaultMessage: "validé" }),
  },
  [HOLDERS_VALIDATION_STATES_VALUE_NOT_VALIDATED]: {
    id: HOLDERS_VALIDATION_STATES_VALUE_NOT_VALIDATED,
    colors: ["orange.600", "orange.300"],
    icon: IoCloseOutline,
    label: defineMessage({ defaultMessage: "non validé" }),
  },
};

// ============================================================

export const HOLDERS_GENDERS_VALUE_MALE = "male";
export const HOLDERS_GENDERS_VALUE_FEMALE = "female";
export const HOLDERS_GENDERS_VALUE_OTHER = "other";

export const HOLDERS_GENDERS = {
  [HOLDERS_GENDERS_VALUE_MALE]: {
    value: HOLDERS_GENDERS_VALUE_MALE,
    civility: defineMessage({ defaultMessage: "Monsieur" }),
  },
  [HOLDERS_GENDERS_VALUE_FEMALE]: {
    value: HOLDERS_GENDERS_VALUE_FEMALE,
    civility: defineMessage({ defaultMessage: "Madame" }),
  },
  [HOLDERS_GENDERS_VALUE_OTHER]: {
    value: HOLDERS_GENDERS_VALUE_OTHER,
    civility: defineMessage({ defaultMessage: "Autre" }),
  },
};

export const HOLDERS_GENDERS_LIST = Object.values(HOLDERS_GENDERS);

// ============================================================

export const HOLDERS_DIETS_VALUE_WITHOUT_PORK = "without_pork";
export const HOLDERS_DIETS_VALUE_WITHOUT_MEAT = "without_meat";

/**
 * @type {Object<string, {
 * value: import("../types/Holder").HolderDiet,
 * name: import("react-intl").MessageDescriptor,
 * }>}
 */
export const HOLDERS_DIETS = {
  [HOLDERS_DIETS_VALUE_WITHOUT_PORK]: {
    value: HOLDERS_DIETS_VALUE_WITHOUT_PORK,
    name: defineMessage({ defaultMessage: "Sans porc" }),
  },
  [HOLDERS_DIETS_VALUE_WITHOUT_MEAT]: {
    value: HOLDERS_DIETS_VALUE_WITHOUT_MEAT,
    name: defineMessage({ defaultMessage: "Sans viande" }),
  },
};

export const HOLDERS_DIETS_LIST = Object.values(HOLDERS_DIETS);

// ============================================================

export const HOLDERS_STATES_VALUE_PENDING = "pending";
export const HOLDERS_STATES_VALUE_ENABLED = "enabled";
export const HOLDERS_STATES_VALUE_DISABLED = "disabled";

export const HOLDERS_STATES = {
  [HOLDERS_STATES_VALUE_PENDING]: {
    id: HOLDERS_STATES_VALUE_PENDING,
    colors: ["purple.600", "purple.300"],
    color: "purple",
    icon: IoEllipsisHorizontalOutline,
  },
  [HOLDERS_STATES_VALUE_ENABLED]: {
    id: HOLDERS_STATES_VALUE_ENABLED,
    colors: ["green.600", "green.300"],
    color: "green",
    icon: IoPlayOutline,
  },
  [HOLDERS_STATES_VALUE_DISABLED]: {
    id: HOLDERS_STATES_VALUE_DISABLED,
    colors: ["purple.600", "purple.300"],
    color: "purple",
    icon: IoPauseOutline,
  },
};

export const HOLDERS_STATES_LIST = Object.values(HOLDERS_STATES);

export const HOLDERS_STATE_MESSAGE = defineMessage({
  defaultMessage:
    "{state, select, enabled {activé} disabled {désactivé} pending {en attente} other {{state}}}",
});

// ============================================================

export const HOLDERS_TYPES_VALUE_CHILD = "child";
export const HOLDERS_TYPES_VALUE_MEMBER = "member";

/** @type {Object<string, {value: string, label: import("react-intl").MessageDescriptor, labelPlural: import("react-intl").MessageDescriptor, description: import("react-intl").MessageDescriptor}>} */
export const HOLDERS_TYPES = {
  [HOLDERS_TYPES_VALUE_CHILD]: {
    value: HOLDERS_TYPES_VALUE_CHILD,
    label: defineMessage({ defaultMessage: "enfant" }),
    labelPlural: defineMessage({ defaultMessage: "enfants" }),
    description: defineMessage({
      defaultMessage:
        "Une personne pouvant accéder aux activités réservées aux enfants.",
    }),
  },
  [HOLDERS_TYPES_VALUE_MEMBER]: {
    value: HOLDERS_TYPES_VALUE_MEMBER,
    label: defineMessage({ defaultMessage: "adulte" }),
    labelPlural: defineMessage({ defaultMessage: "adultes" }),
    description: defineMessage({
      defaultMessage:
        "Une personne pouvant accéder aux activités réservées aux adultes. Elle ne pourra pas accéder aux activités réservées aux enfants.",
    }),
  },
};

export const HOLDERS_TYPES_LIST = Object.values(HOLDERS_TYPES);
